export const GET_BOM_REQUEST = "GET_BOM_REQUEST";
export const GET_BOM_SUCCESS = "GET_BOM_SUCCESS";
export const GET_BOM_FAILURE = "GET_BOM_FAILURE";
